//@flow
import React from 'react';
import createRefContext from '../../../utils/react/refContext';
import type {BulkEditProduct} from '../../../entities';
import {shallowEqual} from 'react-redux';

const {Provider, useStore} = createRefContext();

type Props = {
  children: React$Node,
  product: BulkEditProduct,
};

export function ProductProvider({children, product}: Props) {
  return <Provider data={product}>{children}</Provider>;
}

export function useProductContext<T>(
  selector: (product: BulkEditProduct) => T,
  useShallowEqual: boolean = true //TODO: each call should be implemented its own shallowEqual
): [T, (payload: any) => void] {
  return useStore(selector, useShallowEqual ? shallowEqual : undefined);
}
